module.exports = __webpack_public_path__ + "img/header_logo.0865fab4.svg";